export default "__VITE_ASSET__lw6KSdgX__"